export default function DisplayImage({ imagePath }: { imagePath: string }) {
  return (
    <div className='w-full rounded border-2 flex items-center justify-center group'>
      <img src={imagePath} className='w-20 h-auto' />
    </div>
  )
}
